export const CONTENT = {
  metadata: {
    title: "Stress & Burn-out Coach in Oostvoorne | Liza Moerman",
    description: "Erkend Stress & Burn-out Specialist in Oostvoorne. Begeleiding bij stresspreventie en burn-out herstel via een wetenschappelijk onderbouwde methode.",
    keywords: "burn-out coach Oostvoorne, stress coaching Oostvoorne, stresspreventie Voorne-Putten, mentale vitaliteit, Liza Moerman coach, Coach Voorne aan Zee, Voorne aan Zee, Stress Voorne aan Zee, Coach Voorne Putten, Burn-out Voorne aan Zee, Voorne Putten, Stress Voorne Putten, Burn-out Voorne Putten",
  },
  navigation: {
    home: "Home",
    about: "Over mij",
    expertises: "Expertises",
    werkwijze: "Werkwijze",
    medewerkers: "Voor Medewerkers",
    stressCheck: "Stress-Check",
    tarieven: "Tarieven",
    faq: "FAQ",
    contact: "Contact",
    ctaButton: "Afspraak maken"
  },
  home: {
    metadataTitle: "Liza Moerman | Stress & Burn-out Coach Oostvoorne",
    metadataDescription: "Vind je rust terug met professionele coaching in Oostvoorne. Gespecialiseerd in stresspreventie en burn-out herstel. Plan je gratis kennismaking.",
    heroAlt: "Professionele burn-out coach in Oostvoorne helpt bij stresspreventie en herstel",
    badge: "Erkend Stress & Burn-out Specialist Oostvoorne",
    title: {
      line1: "Stress & Burn-out",
      line2: "coach in Oostvoorne."
    },
    description: "Ik help je bij stresspreventie en burn-out herstel via een wetenschappelijk onderbouwde methode. In mijn praktijk in Voorne aan Zee vinden wij je balans en rust weer terug.",
    buttons: {
      primary: "Gratis Kennismaking",
      secondary: "Bekijk Werkwijze"
    }
  },
  overMij: {
    badge: "Over Liza Moerman",
    badgeSide: "Samen<br/>sterker",
    title: "Waar stress stopt <span class=\"italic font-normal\">&</span> regie begint",
    p1: "In mijn werk als manager in de zorg heb ik gezien hoe professionals vastliepen door stress en burn-out en hun regie verloren. Bevlogen professionals, die met veel inzet en verantwoordelijkheidsgevoel werken, kunnen vastlopen wanneer de druk te hoog wordt en de balans zoekraakt.",
    p2: "Dit geldt niet alleen voor de zorg, maar voor iedereen die zich herkent in het gevoel altijd “aan” te staan, veel van zichzelf vraagt en moeite heeft om grenzen te bewaken.",
    pMore: "Ik geloof dat duurzame verandering begint bij inzicht en eigenaarschap. Vanuit deze overtuiging heb ik mij gespecialiseerd in stress- en burn-out begeleiding. Ik help je om (vroegtijdig) signalen van stress te herkennen, patronen te doorbreken en weer regie te ervaren over je energie, werk en leven.\n\nMijn aanpak is praktisch en doelgericht. We starten met wat er nu speelt en werken stap voor stap toe naar jouw gewenste situatie. Ik ben helder en soms confronterend, maar altijd met respect, betrokkenheid en oog voor wat wél werkt. Met een nuchtere blik en ruimte voor relativering en humor help ik je om weer balans en richting te vinden.\n\nMijn doel is dat jij je werk en leven weer met energie, rust en vertrouwen kunt vormgeven op een manier die echt bij je past.",
    specializationsTitle: "Gespecialiseerd in",
    specializations: ["Stressherstel", "Burn-out herstel", "Stresspreventie"],
    styleTitle: "Mijn stijl",
    styles: ["Persoonlijk", "Veilig & discreet", "Natuurrijk & rustig", "Resultaatgericht"],
    cvButton: "bekijk Curriculum Vitae"
  },
  stressBurnout: {
    badge: "Expertise op Voorne-Putten",
    title: "Effectieve hulp bij <span class=\"italic font-normal\">stress</span> en burn-out.",
    description: "Op zoek naar een gespecialiseerde burn-out coach in Oostvoorne? Ik bied begeleiding die verder gaat dan alleen praten. Met een wetenschappelijk onderbouwde methode kijken we naar zowel je fysieke als mentale herstel in een omgeving van rust.",
    quote: "\"Gespecialiseerde begeleiding verkort de herstelduur bij een burn-out aanzienlijk.\"",
    stats: [
      { label: "Symptomen herkenning", count: "Fysiek & Mentaal" },
      { label: "Persoonlijke coaching", count: "Maatwerk Traject" },
      { label: "Bewezen aanpak", count: "Wetenschappelijk" },
      { label: "Duurzaamheid", count: "Preventie" }
    ],
    whyTitle: "Waarom kiezen voor burn-out coaching in Oostvoorne?",
    whyItems: [
      { title: "Rust & Ruimte", desc: "Een vertrouwde praktijk in Oostvoorne waar de rust van de natuur helpt bij je herstel." },
      { title: "Wetenschappelijke Basis", desc: "Ik werk met methodieken die hun effectiviteit in de praktijk hebben bewezen." },
      { title: "Individuele Focus", desc: "Geen standaardprogramma, maar een traject dat volledig is afgestemd op jouw situatie." }
    ],
    testimonialsBadge: "Social Proof",
    testimonialsTitle: "Coachee Ervaringen",
    stressCheckBadge: "Zelf-analyse",
    stressCheckTitle: "Vind je ritme weer terug",
    stressCheckDesc: "Doe de KIS Stress-Check en ontdek wat je lichaam je probeert te vertellen.",
    tarievenBadge: "Investering in jezelf",
    tarievenTitle: "Trajecten & Mogelijkheden",
    tarievenDesc: "Gespecialiseerde trajecten gericht op duurzaam herstel. Tarieven voor losse gesprekken buiten trajecten zijn op aanvraag beschikbaar.",
    employerTitle: "Bijdrage vanuit je werkgever",
    employerDesc: "Veel werkgevers en CAO's hebben een budget voor persoonlijke ontwikkeling of preventie gereserveerd. Investeren in coaching voorkomt langdurige uitval en wordt daarom vaak (deels) vergoed. Informeer bij je HR-afdeling of leidinggevende naar de mogelijkheden.",
    extraTitle: "Verlenging & Losse Sessies",
    extraDesc: "Wanneer een traject verlengd moet worden, geldt voor extra sessies een uurtarief van € 130,-. Sessies duren gemiddeld 1,5 uur. (zakelijk excl. BTW, particulier incl. BTW)."
  },
  werkwijze: {
    badge: "De Reis",
    title: "In vier fases naar <span class=\"italic font-normal\">eigen regie</span>.",
    steps: [
      { nr: "01", title: "Kennismaking", text: "Een gratis gesprek van +/- 60 minuten om te ontdekken of er een klik is." },
      { nr: "02", title: "Analyse", text: "We duiken in de oorzaken van je stress met een grondige analyse." },
      { nr: "03", title: "Begeleiding", text: "Gerichte coaching en fysiek herstel om je balans te hervinden." },
      { nr: "04", title: "Resultaat", text: "Duurzame rust en regie over je eigen leven en energie." }
    ],
    footerQuote: "\"De gesprekken vinden plaats in mijn rustige praktijkruimte in Oostvoorne, <br class=\"hidden md:block\" /> een plek waar je echt even uit de waan van de dag stapt.\""
  },
  contact: {
    metadataTitle: "Contact | Afspraak maken met Liza Moerman Coach Oostvoorne",
    metadataDescription: "Neem contact op voor een gratis kennismakingsgesprek of stel je vraag. Praktijk voor stress- en burn-out coaching in Oostvoorne.",
    badge: "Samenwerken",
    title: "Laten we kennismaken",
    description: "Heb je een vraag of wil je een eerste gesprek inplannen in mijn praktijk in Oostvoorne?",
    successTitle: "Bedankt voor je bericht",
    successDesc: "Ik neem zo snel mogelijk contact met je op om een moment in te plannen.",
    successButton: "STUUR NOG EEN BERICHT",
    stressCheckAttached: "Stress-check resultaten bijgevoegd",
    stressCheckCount: "Totaal: {score} klachten gemeld.",
    form: {
      name: "Naam",
      namePlaceholder: "Je volledige naam",
      email: "Email",
      emailPlaceholder: "email@voorbeeld.nl",
      phone: "Telefoonnummer",
      phonePlaceholder: "06 12 34 56 78",
      subject: "Onderwerp",
      subjectOptions: ["Kennismaken", "Burn-out Begeleiding", "Stresspreventie", "Zakelijk traject", "Overig"],
      message: "Je bericht",
      messagePlaceholder: "Waar kan ik je bij ondersteunen?",
      verification: "Verificatie",
      verificationPlaceholder: "Antwoord",
      submit: "VERZEND BERICHT",
      submitting: "BEZIG MET VERZENDEN..."
    },
    practiceTitle: "Praktijk Oostvoorne",
    practiceDesc: "Mijn praktijk is gevestigd in een rustige buurt, dicht bij de natuur. De ideale omgeving om weer tot jezelf te komen.",
    addressLabel: "Bezoekadres",
    callLabel: "Bel direct",
    emailLabel: "Email ons",
    routeButton: "Bekijk route"
  },
  medewerkers: {
    metadataTitle: "Coaching voor Medewerkers Oostvoorne | Stress & Burn-out | Liza Moerman",
    metadataDescription: "Voorkom uitval en herstel je werk-privébalans. Gespecialiseerde coaching voor medewerkers in Oostvoorne. Vaak vergoed door werkgevers.",
    badge: "Persoonlijk Traject",
    title: "Voor Medewerkers",
    intro: "Zit je momenteel niet lekker in je vel? Heb je het gevoel dat het emmertje bijna overloopt, of zit je al thuis met burn-out klachten? Je staat er niet alleen voor. Ik bied je een veilige haven om weer tot jezelf te komen.",
    quote: "Duurzame inzetbaarheid begint bij een gezonde balans tussen werk en privé.",
    recognizeTitle: "Herken je dit?",
    symptoms: [
      "Je gaat met tegenzin naar je werk",
      "Je bent prikkelbaar naar je omgeving",
      "Je heb last van hartkloppingen of onrust",
      "Je piekert veel en kunt het niet loslaten",
      "Je vraagt je af: is dit het nou?",
      "Moeite met grenzen stellen",
      "Verminderde motivatie of plezier",
      "Gevoel van controleverlies"
    ],
    offerTitle: "Wat ik je bied",
    offers: [
      "Een veilige, oordeelvrije omgeving",
      "Inzicht in je persoonlijke valkuilen",
      "Praktische tools voor stressmanagement",
      "Herstel van balans en vitaliteit",
      "Begeleiding bij een gezonde werk-privébalans"
    ],
    whyCoachingTitle: "Waarom coaching?",
    whyCoachingDesc: "Coaching helpt je om inzicht te krijgen in je patronen en geeft je praktische handvatten om anders met stressvolle situaties om te gaan. Het doel is niet alleen herstel, maar ook het voorkomen van toekomstige uitval door het vergroten van je veerkracht.",
    reimbursementTitle: "Vergoeding & Traject",
    reimbursementDesc: "Wist je dat veel werkgevers bereid zijn om de kosten voor coaching of hersteltrajecten te vergoeden? Vaak is hiervoor een specifiek preventie- of opleidingsbudget gereserveerd. Het is immers in ieders belang dat jij weer gezond, gemotiveerd en met plezier kunt werken.",
    supportDesc: "Ik kan je ondersteunen bij het voorbereiden van de aanvraag bij je werkgever of HR-afdeling. Daarnaast is het natuurlijk altijd mogelijk om als particulier een traject te starten.",
    reimbursementPoints: [
      { title: "Preventiebudget", desc: "Veel bedrijven hebben een budget voor het voorkomen van verzuim." },
      { title: "Opleidingsbudget", desc: "Coaching wordt vaak gezien als persoonlijke en professionele ontwikkeling." },
      { title: "Arbobeleid", desc: "Trajecten kunnen onderdeel zijn van het herstelplan bij re-integratie." }
    ],
    ctaButton: "Plan een kennismakingsgesprek",
    ctaSub: "Dit gesprek is volledig vertrouwelijk en verplicht je tot niets."
  },
  stressproblematiek: {
    metadataTitle: "De aanpak: stress- en burn-out coaching op maat | Liza Moerman",
    metadataDescription: "Gespecialiseerde stress- en burn-out coaching in Oostvoorne via een effectief 8-stappenplan. Herstel je balans, energie en werkplezier.",
    badge: "Persoonlijke Aanpak",
    title: "De aanpak: stress- en burn-out coaching op maat",
    description: "Een stress- en burn-outcoach biedt een persoonlijke aanpak die volledig is afgestemd op jouw situatie. Samen bepalen we waar jouw behoeften liggen en welke vorm van coaching het beste bij jou past. Zo werken we doelgericht aan het verminderen van stressklachten en het herstellen van balans, energie en werkplezier.",
    stepsTitle: "De coaching bestaat uit een effectief 8-stappen plan:",
    steps: [
      {
        title: "Oriëntatie en intake",
        text: "We starten met een intake waarin we de aard, ernst en duur van jouw stressklachten of burn-out in kaart brengen. Daarnaast bespreken we jouw persoonlijke doelen en verwachtingen. Op basis hiervan stellen we duidelijke prioriteiten en bepalen we de richting van het traject."
      },
      {
        title: "Analyse van stressklachten and stressbronnen",
        text: "Samen onderzoeken we de oorzaken van jouw stress. Je krijgt inzicht in wat energie geeft en wat energie kost – zowel privé als op het werk. Dit vormt de basis voor duurzame verandering."
      },
      {
        title: "Herstel van energie en fysieke conditie",
        text: "Vanaf het begin werken we actief aan herstel. Je leert:",
        list: [
          "luisteren naar je lichaam",
          "signalen van spanning en ontspanning herkennen",
          "beter slapen en ontspannen",
          "piekeren verminderen"
        ],
        subtext: "Zo bouw je stap voor stap je energieniveau weer op."
      },
      {
        title: "Omgaan met stress en emoties",
        text: "Je krijgt inzicht in jouw huidige manier van omgaan met stress. We leren effectieve technieken waarmee je:",
        list: [
          "stressvolle gedachten leert relativeren",
          "emoties beter reguleert",
          "meer rust en controle ervaart"
        ]
      },
      {
        title: "Versterken van persoonlijke vaardigheden",
        text: "Tijdens het traject werken we aan het ontwikkelen van belangrijke competenties, zoals:",
        list: [
          "Zelfvertrouwen",
          "Assertiviteit en grenzen stellen",
          "Plannen en prioriteiten stellen",
          "Omgaan met werkdruk en verstoringen",
          "Conflicten oplossen",
          "Delegeren",
          "Omgaan met veranderingen en tegenslagen"
        ],
        subtext: "Deze vaardigheden helpen je om sterker en veerkrachtiger in het leven te staan."
      },
      {
        title: "Hervinden van jezelf",
        text: "Bij een burn-out raken persoonlijke behoeften en waarden vaak op de achtergrond. In deze fase herontdek je:",
        list: [
          "wat je belangrijk vindt",
          "waar jouw talenten liggen",
          "wat je energie geeft"
        ],
        subtext: "Dit helpt bij het maken van bewuste keuzes voor de toekomst."
      },
      {
        title: "Balans tussen werk en privé",
        text: "We kijken naar de afstemming tussen jouw persoonlijke leven en werksituatie.",
        subsections: [
          {
            title: "Privé",
            list: [
              "Verdeling van taken binnen gezin en sociale omgeving",
              "Omgaan met belastende relaties",
              "Oplossen van eventuele conflicten"
            ]
          },
          {
            title: "Werk",
            list: [
              "Past jouw werk nog bij je?",
              "Wat zijn jouw valkuilen en hulpbronnen?",
              "Welke aanpassingen zijn nodig voor een gezonde werkhervatting?",
              "Hoe voer je het gesprek met je werkgever of leidinggevende?"
            ]
          }
        ]
      },
      {
        title: "Terugvalpreventie en re-integratie",
        text: "In deze fase zijn jouw klachten aanzienlijk verminderd en voel je je sterker. We stellen een concreet plan op voor:",
        list: [
          "een succesvolle re-integratie",
          "het voorkomen van terugval",
          "het behouden van balans en energie op lange termijn"
        ]
      }
    ],
    recovery: {
      title: "Herstel van burn-out: actieve inzet is essentieel",
      text: "Herstellen van stressklachten of een burn-out gebeurt niet vanzelf. Rust alleen is niet voldoende. Duurzaam herstel vraagt om actieve inzet en het doorbreken van oude patronen. Je leert nieuwe vaardigheden en gewoonten aan. Gemiddeld duurt het ongeveer 6 weken van dagelijks oefenen om nieuwe technieken effectief toe te passen, zoals het verminderen van piekeren en beter relativeren."
    },
    confidentiality: {
      title: "Vertrouwelijkheid en professionele begeleiding",
      intro: "Als coach waarborg ik:",
      list: [
        "volledige vertrouwelijkheid",
        "zorgvuldige begeleiding",
        "geen inhoudelijke rapportage aan werkgever zonder jouw toestemming"
      ],
      outro: "Indien gewenst, kan er wel worden afgestemd met HR of leidinggevende over de voortgang (bijvoorbeeld frequentie van gesprekken) of over ondersteunende factoren op de werkvloer."
    },
    results: {
      title: "Resultaat: meer balans, energie en werkplezier",
      intro: "Stress- en burn-out coaching helpt je bij:",
      list: [
        "het herstellen van vitaliteit",
        "het vinden van een gezonde werk-privébalans",
        "het vergroten van veerkracht en effectiviteit",
        "het duurzaam verminderen van stressklachten"
      ],
      outro: "De inzichten en vaardigheden die je opdoet, leveren waardevolle resultaten op voor de rest van je leven en loopbaan."
    },
    contactPrompt: "Wil je meer informatie, neem dan contact op."
  },
  footer: {
    description: "Zoek je een burn-out coach in Oostvoorne of regio Rotterdam? Ik help professionals met stressklachten om weer energie en balans te vinden.",
    navigationLabel: "Navigatie",
    footerQuote: "\"De gesprekken vinden plaats in mijn rustige praktijkruimte in Oostvoorne, <br class=\"hidden md:block\" /> een plek waar je echt even uit de waan van de dag stapt.\"",
    focusLabel: "Focus",
    focus: {
      stressCheck: "Stress-Check",
      stressBurnout: "Stress & Burn-out",
      stressRecovery: "Stressherstel"
    },
    locationLabel: "Locatie",
    addressLabel: "Adres",
    onlineLabel: "Online",
    volgLabel: "Volg mij",
    privacy: "Privacy",
    cookies: "Cookies",
    copyright: "Liza Moerman Coach Oostvoorne.",
    reviews: {
      rating: 5.0,
      count: 12,
      label: "reviews • Uitstekend",
      url: "https://www.google.com/search?q=Liza+Moerman+Coach+Oostvoorne"
    }
  },
  cv: {
    name: "Liza Moerman",
    subtitle: "Coach",
    experience: [
      {
        period: "2026 – heden",
        title: "Liza Moerman Coach",
        description: "Gespecialiseerd in begeleiding bij stressproblematiek en burn-out klachten voor duurzaam herstel."
      },
      {
        period: "2024 – 2026",
        title: "Manager Keten & Capaciteit - Franciscus Gasthuis & Vlietland",
        description: "Verantwoordelijk voor het aansturen en ontwikkelen van het team van personeel- en artsenplanners, met focus op professionalisering en het slimmer en efficiënter organiseren van de planning, zodat deze toekomstbestendig is."
      },
      {
        period: "2021 – 2024",
        title: "Teammanager Dagbehandeling klinische afdelingen - Franciscus Gasthuis & Vlietland",
        description: "Aansturen en begeleiden van een multidisciplinair team binnen verschillende afdelingen, zorgen voor een passende personele bezetting en het soepel laten verlopen van de zorg, met aandacht voor kwaliteit, veiligheid en het continu verbeteren van processen."
      },
      {
        period: "2014 – 2021",
        title: "Verpleegkundige - Franciscus Gasthuis & Vlietland",
        description: "Verlenen van dagelijkse, pre- en postoperatieve patiëntenzorg, uitvoeren van verpleegtechnische handelingen en waarborgen van veilige zorg."
      }
    ],
    education: [
      { year: "2026", name: "Stress en Burn-outcoach ICM" },
      { year: "2025", name: "PHBO/St!R geaccrediteerd Individueel coach" },
      { year: "2022", name: "Klappetraining, chief happiness officer" },
      { year: "2021", name: "Hogeschool Rotterdam Management in de zorg" }
    ],
    strengths: ["Luisteren", "Analyseren", "Compassie", "Resultaatgericht", "Directe communicatie"]
  },
  contact_info: {
    address: "Spechtlaan 10",
    zipCity: "3233 DP Oostvoorne",
    phone: "06 40 67 51 95",
    email: "info@lizamoermancoach.nl",
    fullAddress: "Spechtlaan 10, 3233 DP Oostvoorne",
    whatsapp: "31640675195"
  },
  testimonials: [
    {
      quote: "Liza heeft me geholpen om de signalen van mijn lichaam weer serieus te nemen. De rust in haar praktijk en haar nuchtere aanpak gaven me precies wat ik nodig had.",
      author: "Sophie, Marketing Manager",
      location: "Brielle"
    },
    {
      quote: "Dankzij de specialistische aanpak begreep ik eindelijk waarom ik zo moe bleef. Ik heb nu de tools om mijn energie gedurende de dag te bewaken.",
      author: "Mark, Ondernemer",
      location: "Oostvoorne"
    },
    {
      quote: "Een verademing. Geen zweverig gedoe, maar praktische stappen naar herstel. Ik sta weer met plezier op en ga fluitend naar mijn werk.",
      author: "Annelies, Docent",
      location: "Rockanje"
    }
  ],
  faqs: [
    {
      question: "Hoeveel sessies heb ik gemiddeld nodig?",
      answer: "Voor een traject van 3 maanden kun je rekenen op 6 tot 8 gesprekken. Bij een traject van 6 maanden zijn dit 12 tot 14 gesprekken. Deze spreiding over de looptijd garandeert een duurzaam resultaat."
    },
    {
      question: "Wordt de coaching vergoed door mijn verzekering?",
      answer: "Coaching valt meestal niet onder de basisverzekering. Wel vergoeden veel werkgevers trajecten vanuit het preventie- of opleidingsbudget. Ik denk graag met je mee over de mogelijkheden voor een zakelijke offerte."
    },
    {
      question: "Kan ik ook online sessies volgen?",
      answer: "Ja, dat is mogelijk. Hoewel ik coachees graag in mijn praktijk in Oostvoorne ontvang voor de volledige ervaring en rust, kunnen sessies via beeldbellen een goede aanvulling of alternatief zijn."
    },
    {
      question: "Hoe ziet een traject eruit?",
      answer: "Mijn aanpak richt zich eerst op het fysieke herstel van het ontregelde stress-systeem. Pas als er weer energie is, gaan we aan de slag met coaching op gedrag en mindset."
    }
  ],
  burnoutCoaching: {
    metadataTitle: "Burn-out & Stresscoaching Oostvoorne | Liza Moerman",
    metadataDescription: "Van overleven naar rust, energie en regie. Begeleiding bij stresspreventie en burn-out herstel in Oostvoorne door Liza Moerman.",
    hero: {
      tagline: "Burn-out en stresscoaching in Oostvoorne",
      title: "Van overleven naar rust, energie en regie",
      subText: "Je hoeft niet nog verder vast te lopen om herstel te verdienen.",
      cta: "Plan een vrijblijvende kennismaking"
    },
    recognition: {
      title: "Herkenning",
      subTitle: "Misschien herken je jezelf hierin:",
      items: [
        "Je staat de hele dag “aan”, zelfs als je thuis bent",
        "Je bent snel moe, maar slapen helpt nauwelijks",
        "Je hoofd blijft doorgaan, ook ’s avonds",
        "Kleine dingen voelen al snel te veel",
        "Je werk kost steeds meer energie",
        "Je voelt dat je niet meer goed herstelt"
      ],
      outro: "Je probeert door te gaan, maar merkt dat het niet meer vanzelf gaat."
    },
    benefits: {
      title: "Wat je terug kunt krijgen",
      intro: "In mijn begeleiding werk je aan herstel van lichaam én brein, zodat je weer grip krijgt op je energie en belastbaarheid.",
      subtitle: "Wat veel mensen weer ervaren:",
      items: [
        "meer rust in je hoofd",
        "beter slapen en herstellen",
        "meer energie over de dag",
        "beter grenzen voelen en bewaken",
        "weer vertrouwen in je eigen lichaam",
        "duurzaam herstel, niet alleen tijdelijk oplappen"
      ]
    },
    howIWork: {
      title: "Hoe ik met je werk",
      intro: "Iedere situatie is anders, maar het traject is overzichtelijk opgebouwd:",
      steps: [
        {
          nr: "1",
          title: "Intake & inzicht",
          text: "We brengen in kaart waar je nu staat en wat er speelt."
        },
        {
          nr: "2",
          title: "Herstel & regulatie",
          text: "We werken aan het herstellen van stresssysteem, energie en belasting."
        },
        {
          nr: "3",
          title: "Opbouw & verankering",
          text: "Je leert weer functioneren vanuit rust, met betere grenzen en signalering."
        }
      ]
    },
    aboutShort: {
      title: "Over mij",
      text: "Ik ben Liza Moerman, stress- en burn-outcoach.\n\nIn mijn begeleiding combineer ik kennis over stressfysiologie met een praktische en nuchtere aanpak. Geen zweverigheid, maar inzicht in hoe je systeem werkt en wat jij nodig hebt om te herstellen.\n\nMijn doel is dat jij niet alleen herstelt, maar ook begrijpt hoe je jezelf in de toekomst overeind houdt.",
      cta: "Meer over mij"
    },
    offerings: {
      title: "Mijn begeleiding",
      items: [
        {
          title: "Burn-out hersteltraject",
          desc: "Voor wanneer je bent vastgelopen en echt moet herstellen van langdurige stress of uitputting.",
          focus: "gericht op herstel, energie en stabiliteit"
        },
        {
          title: "Stress- en preventiecoaching",
          desc: "Voor wanneer je merkt dat je richting overspanning gaat en wilt ingrijpen voordat het erger wordt.",
          focus: "gericht op balans, grenzen en preventie"
        }
      ],
      cta: "Bekijk het traject dat bij je past"
    },
    experiences: {
      title: "Ervaringen",
      mainQuote: "“Mensen ervaren vaak al snel meer rust en overzicht, maar vooral het gevoel dat ze weer grip krijgen op hun eigen herstelproces.”"
    },
    closingCta: {
      title: "Twijfel je of dit bij je past of waar je nu staat?",
      tagline: "Je hoeft het niet alleen uit te zoeken.",
      cta: "Plan een vrijblijvende kennismaking",
      outro: "Dan kijken we samen wat jij nodig hebt en of mijn begeleiding daarbij past."
    }
  }
};
